<template>
    <div>
        <div class='product-details-modal-container' v-show='!loading'>
            <div class='product-image-container'>
                <DynamicImageContainer v-if="product.images && product.images.length" class="product-image" :image="product.main_picture"/>
            </div>
            <ProductInfo :product='product' :hide_add_to_cart='true' :product_on_popout='true'/>
            
            <div class='close-button-container' v-if='mobile_mode'>
                <Button class='close-button' text='Close' :theme="(subscription_type == 'wine_club' ? 'yellow' : 'green')" @click='closeProductDetails'/>
            </div>
        </div>

        <div v-if='loading' class='loading-container'>
            <Loading/>
        </div>
    </div>
</template>

<script>
import DynamicImageContainer from "@/ecom/components/images/DynamicImageContainer.vue";
import ProductInfo from '@/ecom/components/products/single_product/details/ProductInfo.vue';
import Loading from '@/ecom/components/loading/Loading.vue';
import Button from '@/ecom/components/buttons/Button.vue';

import {checkAuth, getSubscriptionType, checkOmetriaLoaded} from "@/global/modules/functions.js";

export default {
    components: {DynamicImageContainer, ProductInfo, Loading, Button},
    props: ['product_code', 'open_product_details_modal_watcher'],
    emits: ['closeProductDetailsListener'],
    inject: ['mobile_mode'],
    data(){
        return{
            product: {},
            loading: true,
            subscription_type: ''
        }
    },
    methods:{
        async getProduct(){
            this.loading = true;
            let response = await fetch(`/api/product?product_code=${this.product_code}`, {
                method: 'GET',
                credentials: 'include'
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                this.product = results.product;
                this.loading = false;
                this.subscription_type = getSubscriptionType();
                if(checkOmetriaLoaded()) ometria.init('product', {pid:this.product.code}, '501');
            }
        },
        closeProductDetails(){
            this.$emit('closeProductDetailsListener');
        }
    },
    watch:{
        'open_product_details_modal_watcher': function(){
            this.getProduct();
        }
    }
}
</script>

<style lang="scss" scoped>
.product-details-modal-container{
    display: flex;
    gap: 58px;
    container-type: inline-size;
    align-items: flex-start;

    @media(max-width: 864px){
        flex-direction: column;
    }
}

.product-image-container{
    display: flex;
    justify-content: center;
    width: 100%;
}

.product-image{
    width: 140px;
    object-fit: cover;
    height: 100%;

    @media(max-width: 864px){
        width: 80px;
    }
}


.loading-container{
    width: 75px;
    height: 75px;
    margin: auto;
}

.close-button-container{
    display: flex;
    justify-content: center;
    width: 100%;
}

.close-button{
    width: 200px;
}
</style>